// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Theme fallbacks */
/* Gold palette to match your card/agenda */
.photos {
  font-family: "Great Vibes", cursive; /* requested font for the whole section */
  padding-left: 7px;
  padding-right: 7px;
}

/* Header */
.photos__header {
  display: grid;
  gap: 0.6rem;
  justify-items: center;
  margin-bottom: 0.5rem;
}

.photos__title {
  margin: 0;
  font-weight: 400; /* not bold */
  color: #0b0b0c;
  font-size: clamp(1.6rem, 4.2vw, 2.4rem);
  letter-spacing: 0.1px;
  font-family: "Great Vibes", cursive; /* explicit, as requested */
}

/* Filter chips (no “All” tab anymore) */
.photos__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.photos__chip {
  font-family: "Almendra";
  appearance: none;
  border: 1.5px solid transparent;
  border-radius: 9px;
  padding: 0.35rem 0.75rem;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  color: #0b0b0c;
  font-size: 0.95rem;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, opacity 0.2s ease;
}
.photos__chip:hover {
  transform: translateY(-1px);
}
.photos__chip.is-active {
  box-shadow: 0 0 0 3px rgba(240, 225, 161, 0.35);
}

/* Exact 5 per row × 2 rows (10 total) */
.photos__grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 5 per row */
  gap: 0.6rem;
}

.photo {
  margin: 0;
  border-radius: 14px;
  border: 1.5px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  overflow: hidden;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.05);
  aspect-ratio: 1/1; /* uniform tiles */
}

.photo__inner {
  display: block;
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  border: 0;
  background: transparent;
  cursor: zoom-in;
}
.photo__inner img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
  transition: transform 0.35s ease;
}
.photo__inner:hover img {
  transform: scale(1.03);
}

/* Show more button area */
.photos__actions {
  margin-top: 0.8rem;
  display: grid;
  justify-items: center;
}

/* Lightbox */
.photos__lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(2px);
  display: grid;
  place-items: center;
  z-index: 60;
}

.lightbox__frame {
  position: relative;
  max-width: min(92vw, 1200px);
  max-height: 88vh;
  border-radius: 11px;
  overflow: hidden;
  border: 2px solid transparent;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(135deg, #d4af37, #f0e1a1 40%, #b38728) border-box;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}
.lightbox__frame img {
  display: block;
  max-width: 100%;
  max-height: 88vh;
  width: auto;
  height: auto;
}

.lightbox__close {
  position: absolute;
  top: 8px;
  right: 8px;
  border: 0;
  background: #fff;
  color: #0b0b0c;
  font-size: 1rem;
  line-height: 1;
  border-radius: 999px;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/PhotoComponent/PhotoComponent.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAEhB,oBAAA;AAKA,2CAAA;AAOA;EACE,mCAAA,EAAA,yCAAA;EACA,iBAAA;EACA,kBAAA;AAVF;;AAaA,WAAA;AACA;EACE,aAAA;EACA,WAAA;EACA,qBAAA;EACA,qBAAA;AAVF;;AAaA;EACE,SAAA;EACA,gBAAA,EAAA,aAAA;EACA,cA3BQ;EA4BR,uCAAA;EACA,qBAAA;EACA,mCAAA,EAAA,2BAAA;AAVF;;AAaA,wCAAA;AACA;EACE,aAAA;EACA,eAAA;EACA,WAAA;AAVF;;AAaA;EACE,uBAAA;EACA,gBAAA;EACA,+BAAA;EACA,kBAAA;EACA,wBAAA;EACA,sHACE;EAEF,cAjDQ;EAkDR,kBAAA;EACA,eAAA;EACA,yEAAA;AAZF;AAcE;EAAU,2BAAA;AAXZ;AAYE;EAAc,+CAAA;AAThB;;AAYA,wCAAA;AACA;EACE,aAAA;EACA,qCAAA,EAAA,cAAA;EACA,WAAA;AATF;;AAYA;EACE,SAAA;EACA,mBAAA;EACA,+BAAA;EACA,sHACE;EAEF,gBAAA;EACA,0CAAA;EACA,iBAAA,EAAA,kBAAA;AAXF;;AAcA;EACE,cAAA;EACA,WAAA;EAAa,YAAA;EACb,UAAA;EAAY,SAAA;EAAW,SAAA;EAAW,uBAAA;EAClC,eAAA;AAPF;AASE;EACE,WAAA;EAAa,YAAA;EAAc,cAAA;EAC3B,iBAAA;EAAmB,uBAAA;EACnB,gCAAA;AAJJ;AAOE;EAAc,sBAAA;AAJhB;;AAOA,0BAAA;AACA;EACE,kBAAA;EACA,aAAA;EACA,qBAAA;AAJF;;AAOA,aAAA;AACA;EACE,eAAA;EAAiB,QAAA;EACjB,8BAAA;EACA,0BAAA;EACA,aAAA;EAAe,mBAAA;EACf,WAAA;AAFF;;AAKA;EACE,kBAAA;EACA,4BAAA;EACA,gBAAA;EACA,mBAxGO;EAyGP,gBAAA;EAEA,6BAAA;EACA,sHACE;EAEF,0CAAA;AALF;AAOE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EAAa,YAAA;AAJjB;;AAQA;EACE,kBAAA;EAAoB,QAAA;EAAU,UAAA;EAC9B,SAAA;EAAW,gBAAA;EAAkB,cAnIrB;EAoIR,eAAA;EAAiB,cAAA;EACjB,oBAAA;EAAsB,WAAA;EAAa,YAAA;EACnC,aAAA;EAAe,mBAAA;EACf,yCAAA;EACA,eAAA;AAGF","sourcesContent":["@use \"../styles/tokens\" as *;\r\n\r\n/* Theme fallbacks */\r\n$primary: if(global-variable-exists(color-primary), $color-primary, #7c3aed);\r\n$text:    if(global-variable-exists(color-text),   $color-text,   #0b0b0c);\r\n$muted:   if(global-variable-exists(color-muted),  $color-muted,  #6b7280);\r\n\r\n/* Gold palette to match your card/agenda */\r\n$gold-1: #d4af37;\r\n$gold-2: #f0e1a1;\r\n$gold-3: #b38728;\r\n\r\n$radius: if(global-variable-exists(btn-radius), $btn-radius, 16px);\r\n\r\n.photos {\r\n  font-family: 'Great Vibes', cursive; /* requested font for the whole section */\r\n  padding-left: 7px;\r\n  padding-right: 7px;\r\n}\r\n\r\n/* Header */\r\n.photos__header {\r\n  display: grid;\r\n  gap: .6rem;\r\n  justify-items: center;\r\n  margin-bottom: .5rem;\r\n}\r\n\r\n.photos__title {\r\n  margin: 0;\r\n  font-weight: 400;                 /* not bold */\r\n  color: $text;\r\n  font-size: clamp(1.6rem, 4.2vw, 2.4rem);\r\n  letter-spacing: .1px;\r\n  font-family: 'Great Vibes', cursive;   /* explicit, as requested */\r\n}\r\n\r\n/* Filter chips (no “All” tab anymore) */\r\n.photos__filters {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: .4rem;\r\n}\r\n\r\n.photos__chip {\r\n  font-family: 'Almendra';\r\n  appearance: none;\r\n  border: 1.5px solid transparent;\r\n  border-radius: 9px;\r\n  padding: .35rem .75rem;\r\n  background:\r\n    linear-gradient(#fff, #fff) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n  color: $text;\r\n  font-size: .95rem;\r\n  cursor: pointer;\r\n  transition: transform .15s ease, box-shadow .2s ease, opacity .2s ease;\r\n\r\n  &:hover { transform: translateY(-1px); }\r\n  &.is-active { box-shadow: 0 0 0 3px rgba($gold-2, .35); }\r\n}\r\n\r\n/* Exact 5 per row × 2 rows (10 total) */\r\n.photos__grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(5, 1fr); /* 5 per row */\r\n  gap: .6rem;\r\n}\r\n\r\n.photo {\r\n  margin: 0;\r\n  border-radius: 14px;\r\n  border: 1.5px solid transparent;\r\n  background:\r\n    linear-gradient(#fff, #fff) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 18px rgba(0,0,0,.05);\r\n  aspect-ratio: 1 / 1; /* uniform tiles */\r\n}\r\n\r\n.photo__inner {\r\n  display: block;\r\n  width: 100%; height: 100%;\r\n  padding: 0; margin: 0; border: 0; background: transparent;\r\n  cursor: zoom-in;\r\n\r\n  img {\r\n    width: 100%; height: 100%; display: block;\r\n    object-fit: cover; object-position: center;\r\n    transition: transform .35s ease;\r\n  }\r\n\r\n  &:hover img { transform: scale(1.03); }\r\n}\r\n\r\n/* Show more button area */\r\n.photos__actions {\r\n  margin-top: .8rem;\r\n  display: grid;\r\n  justify-items: center;\r\n}\r\n\r\n/* Lightbox */\r\n.photos__lightbox {\r\n  position: fixed; inset: 0;\r\n  background: rgba(0,0,0,.6);\r\n  backdrop-filter: blur(2px);\r\n  display: grid; place-items: center;\r\n  z-index: 60;\r\n}\r\n\r\n.lightbox__frame {\r\n  position: relative;\r\n  max-width: min(92vw, 1200px);\r\n  max-height: 88vh;\r\n  border-radius: $radius;\r\n  overflow: hidden;\r\n\r\n  border: 2px solid transparent;\r\n  background:\r\n    linear-gradient(#fff, #fff) padding-box,\r\n    linear-gradient(135deg, $gold-1, $gold-2 40%, $gold-3) border-box;\r\n  box-shadow: 0 12px 30px rgba(0,0,0,.3);\r\n\r\n  img {\r\n    display: block;\r\n    max-width: 100%;\r\n    max-height: 88vh;\r\n    width: auto; height: auto;\r\n  }\r\n}\r\n\r\n.lightbox__close {\r\n  position: absolute; top: 8px; right: 8px;\r\n  border: 0; background: #fff; color: $text;\r\n  font-size: 1rem; line-height: 1;\r\n  border-radius: 999px; width: 32px; height: 32px;\r\n  display: grid; place-items: center;\r\n  box-shadow: 0 2px 10px rgba(0,0,0,.2);\r\n  cursor: pointer;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
